/*=========================================================================================
  File Name: moduleLearningHub.js
  Description: Learning Hub Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Sib
  Author URL: http://www.organix-it.com
==========================================================================================*/

import state from './moduleLearningHubState.js'
import mutations from './moduleLearningHubMutations.js'
import actions from './moduleLearningHubActions.js'
import getters from './moduleLearningHubGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}